"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cubby = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactTransitionGroup = require("react-transition-group");
var _Overlay = require("../Overlay");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Can also refer to CSSTransition documentation for other useful props,
 * such as unmountOnExit
 * http://reactcommunity.org/react-transition-group/css-transition
 */
var Cubby = function Cubby(_ref) {
  var children = _ref.children,
    cubbyStyles = _ref.cubbyStyles,
    onClose = _ref.onClose,
    onEnter = _ref.onEnter,
    onEntered = _ref.onEntered,
    onEntering = _ref.onEntering,
    onExit = _ref.onExit,
    onExited = _ref.onExited,
    onExiting = _ref.onExiting,
    overlayStyles = _ref.overlayStyles,
    visible = _ref.visible,
    _ref$unmountOnExit = _ref.unmountOnExit,
    unmountOnExit = _ref$unmountOnExit === void 0 ? false : _ref$unmountOnExit;
  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: !!visible,
    timeout: _Overlay.OVERLAY_ANIMATION_DURATION,
    onEnter: onEnter,
    onEntered: onEntered,
    onEntering: onEntering,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    unmountOnExit: unmountOnExit
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, {
    visible: visible,
    className: overlayStyles,
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('bg-white overflow-y-auto', cubbyStyles),
    style: {
      transform: "translate(".concat(visible ? 0 : 100, "%, 0%)"),
      opacity: visible ? 1 : 0,
      transition: "opacity ".concat(_Overlay.OVERLAY_ANIMATION_DURATION, "ms ease-in-out, transform ").concat(_Overlay.OVERLAY_ANIMATION_DURATION, "ms ease-in-out")
    }
  }, children)));
};
exports.Cubby = Cubby;